module.exports = __webpack_public_path__ + "static/logos/apple-logo--black-293f17a284a0529e81d577ec5d018b7d.svg";